export default __webpack_public_path__ + "static/media/max.f5efb9ad.svg";